import React from 'react';
import { useText } from '../../lib/siteContent';
import { motion } from 'framer-motion';
import { responsiveImg } from '../../lib/imageUrl';
import { useSlotImage } from '../../lib/useSlotImage';
import { MAISON_FALLBACK } from '../../lib/universes';
import { TextLink } from './TextLink';

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

const MaisonSection = ({ asPage = false }) => {
  const image = useSlotImage('maison', MAISON_FALLBACK);
  const t = useText();
  const Heading = asPage ? motion.h1 : motion.h2;

  return (
    <section id="maison" className={`bg-[#FFFFFF] ${asPage ? 'pt-20 md:pt-28 pb-32' : 'py-32 md:py-48'}`} data-testid="maison-section">
      <div className="container-custom grid grid-cols-1 lg:grid-cols-[55fr_45fr] gap-16 lg:gap-20">
        <div className="flex flex-col lg:py-16">
          <motion.span {...reveal} className="text-[11px] uppercase tracking-[0.3em] text-[#111111] mb-10 md:mb-14" data-testid="maison-label">
            {t('maison.label')}
          </motion.span>
          <Heading {...reveal} transition={{ ...reveal.transition, delay: 0.1 }} className="font-serif font-light text-[#111111] text-5xl sm:text-6xl lg:text-7xl xl:text-[5rem] leading-[1.02] tracking-[-0.01em] mb-12 md:mb-16" data-testid="maison-headline">
            <span className="whitespace-pre-line">{t('maison.headline')}</span>
          </Heading>
          <motion.p {...reveal} transition={{ ...reveal.transition, delay: 0.2 }} className="text-[#333333] text-sm md:text-base leading-[1.9] font-light max-w-md" data-testid="maison-paragraph">
            {t('maison.paragraph')}
          </motion.p>
          {!asPage && (
            <motion.div {...reveal} transition={{ ...reveal.transition, delay: 0.3 }} className="mt-14 lg:mt-auto lg:pt-16">
              <TextLink to="/la-maison" testId="maison-cta">{t('maison.cta')}</TextLink>
            </motion.div>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 1.4 }}
          className="aspect-[4/5] lg:aspect-[3/4] overflow-hidden bg-[#F5F5F5]"
        >
          <img {...responsiveImg(image, '(max-width: 768px) 100vw, 50vw')} alt="Détail de préparation florale — image d'illustration" className="w-full h-full object-cover" data-testid="maison-image" />
        </motion.div>
      </div>
    </section>
  );
};

export default MaisonSection;
